export default __webpack_public_path__ + "static/media/171.a51e9fae.png";